import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'
import './PageHeader.css'

/**
 * PageHeader Component
 *
 * Consistent header for all pages with breadcrumbs and action buttons
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description (optional)
 * @param {Array} props.breadcrumbs - Breadcrumb items array
 * @param {React.ReactNode} props.actions - Action buttons (optional)
 * @param {React.ReactNode} props.children - Additional content (optional)
 *
 * Breadcrumb format: [{ label: 'Home', path: '/' }, { label: 'Users' }]
 * Last item is current page (no path)
 */
const PageHeader = ({ title, description, breadcrumbs = [], actions, children }) => {
	return (
		<div className="page-header">
			<div className="page-header__main">
				{/* Breadcrumbs in top right corner */}
				{breadcrumbs.length > 0 && (
					<nav className="page-header__breadcrumbs" aria-label="Breadcrumb">
						<ol className="breadcrumbs">
							<li className="breadcrumbs__item">
								<Link to="/" className="breadcrumbs__link">
									<Home size={14} />
								</Link>
							</li>
							{breadcrumbs.map((crumb, index) => (
								<li key={index} className="breadcrumbs__item">
									<ChevronRight size={14} className="breadcrumbs__separator" />
									{crumb.path ? (
										<Link to={crumb.path} className="breadcrumbs__link">
											{crumb.label}
										</Link>
									) : (
										<span className="breadcrumbs__current">{crumb.label}</span>
									)}
								</li>
							))}
						</ol>
					</nav>
				)}

				{/* Title/Description on left */}
				<div className="page-header__content">
					<h1 className="page-header__title">{title}</h1>
					{description && <p className="page-header__description">{description}</p>}
				</div>

				{/* Actions at bottom right corner */}
				{actions && <div className="page-header__actions">{actions}</div>}
			</div>

			{/* Additional Content */}
			{children && <div className="page-header__extra">{children}</div>}
		</div>
	)
}

export default PageHeader
